// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSquareTerminal as RawLucideSquareTerminal } from "lucide-react";
export const LucideSquareTerminal = /* @__PURE__ */ createIcon(RawLucideSquareTerminal, "LucideSquareTerminal", 2);
